import { BASE_API_URL } from "../../config/Api";
import {
  CREATE_TASK,
  TASK_MASTER_LIST,
  PROJECT_DROPDOWN,
  TASK_DATA_EDIT,
  TASK_TRANSACTION_LIST,
  TASK_REPORT_EMP_WISE,
  TASK_TYPE,
  TASK_PRIORITY,
  TASK_STATUS,
  TASK_ASSIGN_LIST,
  TASK_COMMENT,
  TASK_WORKLOG,
  TASK_WORKLOG_DATA,
  TASK_COMMENT_DATA,
  TASK_MASTER_DASH_DATA,
  TASK_NO_SEARCH_LIST,
  TASK_DETAILS,
  FETCH_WORKLOG_DATA,
  FETCH_TASK_PROJECTWISE_DATA,
  TODAYS_WORKLOG_DATA_BYID,
  EMP_TASK_COUNT_LIST,
} from "./ActionType";

export const taskMasterList = (token, pageNumber, pageSize, loginId, roleName) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/taskMasterList?pageSize=${pageSize}&pageNo=${pageNumber}&loginId=${loginId}&role=${roleName}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: TASK_MASTER_LIST, payload: resData });
  } catch (error) { }
};

export const getProjectMaster = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getProjectMaster`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: PROJECT_DROPDOWN, payload: resData });
  } catch (error) { }
};

export const getcreateTask = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/createTask`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: CREATE_TASK, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const getTaskDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchTaskDetails?hrmsTaskMasterId=${loginId} `,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: TASK_DATA_EDIT, payload: resData });
    return resData;
  } catch (error) { }
};

export const getTaskReportEmployeeWise =
  (assignId, startDate, endDate, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/taskReportEmployeeWise?assignId=${assignId}&endDate=${endDate}&startDate=${startDate}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: TASK_REPORT_EMP_WISE, payload: resData });
      return resData;
    } catch (error) { }
  };

export const gettaskstatus = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getTicketStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: TASK_STATUS, payload: resData });
  } catch (error) { }
};

export const gettaskpriority = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getTicketPriority`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: TASK_PRIORITY, payload: resData });
  } catch (error) { }
};

export const gettasktype = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getTicketType`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: TASK_TYPE, payload: resData });
  } catch (error) { }
};

export const gettaskMasterListForAssign = (token, pageNumber, pageSize) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/taskMasterListForAssign?pageSize=${pageSize}&pageNo=${pageNumber}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: TASK_ASSIGN_LIST, payload: resData });
  } catch (error) { }
};

export const addTaskComment = (commentData, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/addComments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(commentData),
    });
    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: TASK_COMMENT, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};
export const addTaskWorklog = (WorkLogdata, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/createWorkLog`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(WorkLogdata),
    });

    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: TASK_WORKLOG, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) {
    console.error("Error creating work log:", error);
    return { success: false, error: "Network error occurred" };
  }
};

export const getWorklogData = (hrmsTaskMasterId, token, loginId) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchTaskWorkLog?hrmsTaskMasterId=${hrmsTaskMasterId}&loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: TASK_WORKLOG_DATA, payload: resData });
  } catch (error) { }
};

export const getCommentData = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchTaskComments?hrmsTaskMasterId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: TASK_COMMENT_DATA, payload: resData });
    return resData;
  } catch (error) { }
};

export const getTaskDashbordDataEmployeeWise =
  (assignId, status, projectCode, token, pageNumber, pageSize) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/taskMasterListDash?assignId=${assignId}&projectCode=${projectCode}&status=${status}&pageSize=${pageSize}&pageNo=${pageNumber}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: TASK_MASTER_DASH_DATA, payload: resData });
      return resData;
    } catch (error) { }
  };
export const taskNoSearchList = (token, taskNo) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/searchByTaskNo?taskNo=${taskNo}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: TASK_NO_SEARCH_LIST, payload: resData });
  } catch (error) { }
};

export const getAllTaskDetailsByloginId = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/allTaskDetailsById?loginId=${loginId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: TASK_DETAILS, payload: resData });
    return resData;
  } catch (error) { }
};

export const fetchWorkLogData = (loginId, token, fromDate, toDate) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchWorkLogData?loginId=${loginId}&fromDate=${fromDate}&toDate=${toDate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: FETCH_WORKLOG_DATA, payload: resData });
  } catch (error) { }
};

export const getTaskDataProjectWiseData = (token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchTaskDataProjectWise`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: FETCH_TASK_PROJECTWISE_DATA, payload: resData });
  } catch (error) { }
};

export const fetchTodyasWorkLogDataByLogind = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchTodaysWorkLogDataByLogind?loginId=${loginId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: TODAYS_WORKLOG_DATA_BYID, payload: resData });
  } catch (error) { }
};

export const getEmpTaskCountList = ( token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/getEmpTaskCountList`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: EMP_TASK_COUNT_LIST, payload: resData });
  } catch (error) { }
};

export const getTaskTransactionDetails = (hrmsTaskMasterId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchTaskTransactionDetails?hrmsTaskMasterId=${hrmsTaskMasterId} `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: TASK_TRANSACTION_LIST, payload: resData });
    return resData;
  } catch (error) { }
};